/** @prettier */
import React from "react";
import ReactTable, { Column } from "react-table";
import { displayTestMode } from "../Test/models";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TestProgressData } from "./dashboardApi";
import moment from "moment";

const headerStyle = { fontWeight: "bold", textAlign: "start" };

const columns: Array<Column<TestProgressData>> = [
    {
        Header: "Date",
        id: "createdDate",
        headerStyle,
        accessor: ({ createdDate }) => moment(createdDate).format("YYYY-MM-DD"),
        width: 85,
    },
    {
        Header: "Test Name",
        id: "name",
        headerStyle,
        accessor: ({ testName }) => <span title={testName}>{testName}</span>,
        width: 140,
    },
    {
        Header: "Mode",
        id: "mode",
        headerStyle,
        accessor: ({ mode }) => displayTestMode(mode),
        width: 85,
    },
    {
        Header: "%",
        id: "answered",
        headerStyle,
        getHeaderProps: () => ({ title: "Answered/Total" }),
        accessor: ({ answeredQuestions, totalQuestions }) =>
            `${answeredQuestions}/${totalQuestions}`,
        width: 45,
    },
    {
        Header: "Resume",
        id: "resume",
        headerStyle,
        className: "cell-center",
        width: 65,
        accessor: ({ testUuid, testName }) => (
            <Link to={`/tests/${testUuid}/run`} title={`Resume "${testName}"`}>
                <FontAwesomeIcon icon="play" />
            </Link>
        ),
    },
];

export type TestProgressTableProps = { data: TestProgressData[] };
const TestProgressTable = ({ data }: TestProgressTableProps) => {
    return (
        <ReactTable
            className="tre-question-list-table"
            data={data}
            columns={columns}
            showPagination={false}
            minRows={0} // Don't show more rows than we have data for
            pageSize={10}
        />
    );
};

export default TestProgressTable;
